export default {
  metadata: {
    version: '1.0.0',
    id: 'menu-block-item-1.0.0',
    name: 'JDSMenuBlockItem'
  },
  hierarchy: {
    container: [
      {
        'entry-container': [
          {
            'left-container': [
              {
                'prefix-jds-icon-container': ['prefix-jds-icon']
              },
              'entry-jds-text'
            ]
          },
          {
            'suffix-jds-icon-container': ['suffix-jds-icon']
          }
        ]
      },
      {
        'divider-container': ['jds_divider']
      },
      {
        'heading-container': ['heading-jds-text']
      }
    ]
  },
  base: {
    container: {
      opacity: '{m_0}',
      'background-color': '{m_1}',
      width: '{m_2}'
    },
    'entry-container': {
      hidden: false,
      'background-color': '{m_3}',
      width: '{m_4}',
      'padding-top': '{m_5}',
      'padding-right': '{m_6}',
      'padding-bottom': '{m_7}',
      'padding-left': '{m_8}',
      'flex-direction': '{m_9}',
      'align-items': '{m_10}',
      'justify-content': '{m_11}',
      'border-width': 0,
      'border-color': '{m_12}',
      'border-radius': 0,
      behavior: {
        hover: {
          'background-color': '{m_13}'
        },
        focus: {
          'border-width': 2,
          'border-color': '{m_14}',
          'border-radius': '{m_15}'
        }
      }
    },
    'divider-container': {
      hidden: true,
      width: '{m_16}'
    },
    jds_divider: {
      pad: 'none',
      orientation: 'horizontal'
    },
    'heading-container': {
      hidden: true,
      'padding-top': '{m_17}',
      'padding-right': '{m_18}',
      'padding-bottom': '{m_19}',
      'padding-left': '{m_20}',
      width: '{m_21}',
      'align-items': '{m_22}',
      'justify-content': '{m_23}'
    },
    'left-container': {
      gap: '{m_24}',
      'flex-direction': '{m_25}',
      'align-items': '{m_26}'
    },
    'prefix-jds-icon': {
      size: '{icon_5}',
      color: '{icon_15}',
      hidden: true
    },
    'prefix-jds-icon-container': {
      'background-color': '{icon_0}',
      'border-radius': '{icon_1}',
      size: '{icon_2}',
      'justify-content': '{icon_3}',
      'align-items': '{icon_4}',
      hidden: true
    },
    'entry-jds-text': {
      'font-family': '{text_132}',
      color: '{text_21}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    },
    'suffix-jds-icon': {
      size: '{icon_5}',
      color: '{icon_15}'
    },
    'suffix-jds-icon-container': {
      'background-color': '{icon_0}',
      'border-radius': '{icon_1}',
      size: '{icon_2}',
      'justify-content': '{icon_3}',
      'align-items': '{icon_4}'
    },
    'heading-jds-text': {
      'font-family': '{text_147}',
      color: '{text_20}',
      'font-size': '{text_146}',
      'line-height': '{text_148}',
      'letter-spacing': '{text_149}',
      'font-weight': '{text_150}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {
    type: {
      divider: {
        'entry-container': {
          hidden: true
        },
        'divider-container': {
          hidden: false
        }
      },
      heading: {
        'entry-container': {
          hidden: true
        },
        'heading-container': {
          hidden: false
        }
      }
    },
    selected: {
      true: {
        container: {
          'background-color': '{m_27}'
        }
      }
    },
    disabled: {
      true: {
        container: {
          disabled: true,
          opacity: '{m_28}'
        }
      }
    },
    hasIcon: {
      true: {
        'heading-container': {
          'padding-left': '{m_29}'
        },
        'prefix-jds-icon': {
          hidden: false
        },
        'prefix-jds-icon-container': {
          hidden: false
        }
      }
    }
  },
  api: {
    config: {
      type: {
        values: ['entry', 'divider', 'heading']
      },
      selected: {
        values: [false, true]
      },
      disabled: {
        values: [false, true]
      },
      hasIcon: {
        values: [false, true]
      }
    },
    data: {
      container: {
        '_item.value': {
          type: 'string',
          name: 'value'
        }
      },
      'entry-jds-text': {
        value: {
          type: 'string',
          name: 'label'
        }
      },
      'prefix-jds-icon': {
        value: {
          type: 'icon',
          name: 'prefix'
        }
      },
      'suffix-jds-icon': {
        value: {
          type: 'icon',
          name: 'suffix'
        }
      },
      'heading-jds-text': {
        value: {
          type: 'string',
          name: 'label'
        }
      }
    },
    events: {
      'entry-container': {
        onClick: 'onSelect'
      }
    },
    a11y: {
      'entry-container': {
        properties: {
          role: {
            value: 'menuitem'
          },
          'aria-label': {
            name: 'ariaLabel',
            prop: 'label'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
